import { NgClass } from "@angular/common";
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { IOption } from "~app/common/models/options-models";
import { InfoComponent } from "../info/info.component";

@Component({
    selector: "rask-action-button",
    styleUrls: ["./action-button.component.scss"],
    templateUrl: "./action-button.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InfoComponent,
        NgClass
    ]
})
export class ActionButtonComponent extends ButtonComponent implements OnInit, OnDestroy {

    @Input() options: IOption[];
    @Input() alignment = "left";
    @Input() showChevron = true;

    @Output() optionSelected = new EventEmitter<IOption>();
    showOptions = false;

    private readonly elementRef = inject(ElementRef);
    private readonly zone = inject(NgZone);

    ngOnInit(): void {
        super.ngOnInit();
        this.zone.runOutsideAngular(() => {
            document.addEventListener("click", this.clickOut);
        });
    }

    ngOnDestroy(): void {
        document.removeEventListener("click", this.clickOut);
    }

    clickOut = (event) => {
        if (!this.showOptions || this.elementRef.nativeElement.contains(event.target)) {
            return;
        }
        this.showOptions = false;
        this.cdRef.detectChanges();
    };

    toggle($event) {
        if (this.options?.length > 0) {
            this.showOptions = !this.showOptions;
            $event.stopPropagation();
        }
    }

    optionClicked(option) {
        this.optionSelected.emit(option);
        this.showOptions = false;
    }
}
